import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    fetchSelfAssessment, updateSelfAssessment,
    SELF_ASSESSMENT_FETCH_REQUEST, SELF_ASSESSMENT_FETCH_SUCCESS, SELF_ASSESSMENT_FETCH_FAILURE,
    SELF_ASSESSMENT_UPDATE_REQUEST, SELF_ASSESSMENT_UPDATE_SUCCESS, SELF_ASSESSMENT_UPDATE_FAILURE
} from './actions';
import { withTranslation } from 'react-i18next';
import FormComponents from '../assessmentForms/Components';
import AssessmentForm from '../assessmentForms/Form';
import { SubmissionError } from 'redux-form';
import { getFormValues, change, clearSubmitErrors } from 'redux-form';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getChild } from '../reducer';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';

class FormDetails extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { childId, formId, fetchSelfAssessment } = this.props;
        if (childId && formId) {
            fetchSelfAssessment(childId, formId);
        }
    }

    handleFormSubmit(values, isFinal, requiredFields, validationFunc) {
        const { t, selfAssessment, updateSelfAssessment, clearFormErrors } = this.props;

        clearFormErrors();

        if (isFinal) {
            let errors = {};
            if (requiredFields) {
                requiredFields.forEach(field => {
                    if (values[field] == null || values[field] === '') {	// null, undefined or empty are invalid, 0 is a valid value
                        errors[field] = t('Validator_Required');
                    }
                });
            }

            if (validationFunc) {
                errors = Object.assign(errors, validationFunc(values, t));
            }

            // throw redux-form error if fields are missing when submiting form in Final status
            if (Object.keys(errors).length > 0) {
                toast.error(t('FO_IndividualConsultationForm_ValidationErrors'));
                throw new SubmissionError(errors);
            }
        }

        const onSuccess = () => toast.success(t(isFinal ? 'FO_IndividualConsultationForm_Final_Saved' : 'FO_IndividualConsultationForm_Draft_Saved'));
        const onError = (errorMessage) => toast.error(errorMessage);

        updateSelfAssessment({ ...selfAssessment, content: values, isFinal }, onSuccess, onError);
    }

    render() {
        const { child, selfAssessment, currentFormValues, changeFormValue, t } = this.props;
        const { component, requiredFields, validationFunc } = selfAssessment ? FormComponents(selfAssessment, { showResults: selfAssessment.status === 'Final' }, currentFormValues, changeFormValue) : {
            component: null, requiredFields: [], validationFunc: null
        };

        return <div>
            <h3>{child && child.fullName}</h3>
            <ReduxBlockUi block={[SELF_ASSESSMENT_FETCH_REQUEST, SELF_ASSESSMENT_UPDATE_REQUEST]}
                unblock={[SELF_ASSESSMENT_FETCH_SUCCESS, SELF_ASSESSMENT_FETCH_FAILURE, SELF_ASSESSMENT_UPDATE_SUCCESS, SELF_ASSESSMENT_UPDATE_FAILURE]}>
                {selfAssessment && <AssessmentForm
                    title={selfAssessment.name && t(`AssessmentForm_SelfAssessment_${selfAssessment.name}`)}
                    description={t('FO_SelfAssessmentForm_Hint')}
                    formComponent={component}
                    backPath={`/self-assessments/${child ? child.id : ''}`}
                    submitFinalButtonText={t('FO_SelfAssessmentForm_SaveFinal')}
                    onSubmit={(values, isFinal) => this.handleFormSubmit(values, isFinal, requiredFields, validationFunc)}
                    initialValues={selfAssessment.content}
                    isReadonly={selfAssessment.status === 'Final'}
                />}
            </ReduxBlockUi>
            <ToastContainer theme='colored' />
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const { entities: { selfAssessments }, lookups: { selfAssessmentForms }, parent } = state;
    const { formId, childId } = ownProps.match.params;
    const form = selfAssessmentForms && selfAssessmentForms.find(x => x.id === Number(formId));

    const selfAssessment = selfAssessments[`${childId}|${formId}`] || {
        id: 0,
        formId: Number(formId),
        childId: Number(childId),
        name: form && form.name,
        content: {}
    };

    return {
        childId: Number(childId),
        formId: Number(formId),
        selfAssessment,
        currentFormValues: getFormValues('customForm')(state),
        child: getChild(parent, childId)
    };
};

export default connect(mapStateToProps, {
    fetchSelfAssessment,
    updateSelfAssessment,
    changeFormValue: (field, value) => change('customForm', field, value),
    clearFormErrors: () => clearSubmitErrors('customForm')
})(withTranslation()(FormDetails));